import React from 'react';
import './DashboardView.css';

function ShoppingList() {

    return (
        <div>

            <div>
                <iframe src="https://to-do.live.com/tasks/" width="800" height="400" frameborder="0" scrolling="no"></iframe>

                {/* <iframe height="500" width="700" src="https://yourtenant.sharepoint.com/personal/yourtenant_onmicrosoft_com/_layouts/15/WopiFrame.aspx?folderid=12705a52a8b974053a0e3affec0eb34d6&authkey=AVlDo1i1uNrEtYD8uq4Inzs&action=embedview&wdbipreview=true"></iframe> */}
            </div>

        </div>
    );
}

export default ShoppingList;